/* eslint-disable */
export default {
  forward: 'Transférer',
  reply: 'Répondre',
  ignore: 'Ignorer',
  toVoicemail: 'À la messagerie vocale',
  answer: 'Répondre',
  answerAndEnd: 'Répondre et raccrocher',
  answerAndHold: 'Répondre et mettre en attente',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
